const path = "/remocao";
export default {
  validarServidor: (cpf, ano) => `${path}/pre-inscricao/validar-servidor/${cpf}/${ano}`,
  localizardatasEventos: `${path}/data-distribuicao`,
};
